import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const RichTextEditor = ({
  label,
  value,
  onChange,
  placeholder = 'Bir şeyler yazın...',
  error,
  className = ""
}) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
  ];

  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <div className={`bg-white rounded-md overflow-hidden border ${error ? 'border-red-500' : 'border-gray-300'}`}>
        <ReactQuill
          theme="snow"
          value={value}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          className="rich-text-editor"
        />
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}

      <style>{`
        .rich-text-editor .ql-container {
          min-height: 150px;
          font-family: inherit;
        }
        .rich-text-editor .ql-editor {
          font-size: 14px;
        }
        .rich-text-editor .ql-toolbar {
          border: none;
          border-bottom: 1px solid #e5e7eb;
        }
        .rich-text-editor .ql-container {
          border: none;
        }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
